/** Root layout · Patch 36.0 · Project Obsidian.
 *
 * The legacy full-screen "Executive Briefing" daily modal (M10.5) has
 * been retired — the Akinex Executive Briefing Card on Executive Home
 * is now the single canonical daily hub (see Patch 35.5.1 + 36.0).
 */
import { Outlet } from "react-router-dom";

import { useBootstrapWorkspace, useEnsureWorkspaceForAuthedUser } from "@/entities/workspace";
import { useAutoCreateWorkspaceFromOnboarding } from "@/entities/workspace/useAutoCreateWorkspaceFromOnboarding";
import { Topbar } from "@/widgets/AppShell";
import { DemoBanner } from "@/widgets/DemoBanner/DemoBanner";
import { GuestBanner } from "@/widgets/GuestBanner/GuestBanner";
import { PublicPreviewBanner } from "@/widgets/PublicPreviewBanner/PublicPreviewBanner";
import { PreferredNamePrompt } from "@/features/preferred-name-prompt/PreferredNamePrompt";
import { UpgradeModal } from "@/features/entitlements/UpgradeModal";
import { useWorkspaceTint } from "@/shared/lib/useWorkspaceTint";
import { config } from "@/shared/config";

export function RootLayout(): JSX.Element {
  useBootstrapWorkspace();
  useAutoCreateWorkspaceFromOnboarding();
  // Patch 37.4.13 — after hydration, if an authenticated visitor has
  // ZERO workspaces (e.g. a brand-new Google OAuth account with no
  // onboarding draft), redirect to /workspaces/new. Without this,
  // workspace-scoped pages render an indefinite "Loading workspace…"
  // placeholder because ``useCurrentWorkspace()`` returns null.
  useEnsureWorkspaceForAuthedUser();
  useWorkspaceTint();

  return (
    <div className="flex min-h-screen flex-col text-[var(--md-ivory-0)]">
      <GuestBanner />
      <DemoBanner />
      <PublicPreviewBanner />
      <Topbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-[color:var(--md-line)] px-6 py-4 md-eyebrow">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-2">
          <span>© 2026 Orkexra™ · Orchestrate. Automate. Grow.</span>
          <span>
            Blueprint {config.blueprint} · {config.milestone}
          </span>
        </div>
      </footer>
      <PreferredNamePrompt />
      <UpgradeModal />
    </div>
  );
}
